import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import 'firebase/compat/auth'

import config from '@/utils/config.js'
import createChangeset from '@/utils/createChangeset'

const db = firebase
  .initializeApp({
    apiKey: config('FIREBASE_API_KEY'),
    projectId: config('FIREBASE_PROJECT_ID'),
  })
  .firestore()

export const serverTimestamp = () =>
  firebase.firestore.FieldValue.serverTimestamp()

export const signInWithCustomToken = (token) =>
  firebase.auth().signInWithCustomToken(token)

export const COMMENTS = 'report_comments'

export const commentsCollection = db.collection(COMMENTS)

// { collection = [], meta = {}, record: {}, values: {} }
export const updateRecord = (options = {}) => {
  // eslint-disable-next-line no-console
  console.log(options)
  return createChangeset(options)
}

/**
 * Subscribe to Hermes job status updates for a specific job by ID
 * Listens directly to the job document for reliable status updates
 * @param {string} jobId - The job UUID (document ID in hermes_job_status collection)
 * @param {Function} callback - Called with job status on each change
 * @param {Function} errorCallback - Called on error
 * @returns {Function} Unsubscribe function
 */
export const subscribeToHermesJobById = (jobId, callback, errorCallback) => {
  return db
    .collection('hermes_job_status')
    .doc(jobId)
    .onSnapshot((doc) => {
      if (doc.exists) {
        callback(doc.data())
      }
    }, errorCallback)
}

export default db
